import React from "react";
import { message } from "antd";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import MainPage from "../../MainPage";
import {
  apiCallback,
  statusChangeApiCallback,
} from "../../../ApiHandlers/Common";
import ListServiceProviderConfig from "./ListServiceProviderConfig";
import ServiceProviderConfigForm from "./ServiceProviderConfigForm";
import { EntityStatus, NavMenuItems } from "../../../Constants/Constants";
import { convertServiceProviderConfigList } from "../../../Helpers/ConfigHelpers";
import { convertServiceProviderListToDropdown } from "../../../Helpers/ServiceProviderHelpers";

class ServiceProviderConfig extends React.Component {
  constructor(props) {
    super(props);
    this.header = [
      ...(props.parentBread || []),
      <>
        {NavMenuItems.configuration.icon()}
        <span>{NavMenuItems.configuration.serviceProvider.label}</span>
      </>,
    ];
    this.state = {
      action: null,
      record: null,
      providerData: [],
      providerDataLoading: false,
      selectedProvider: null,
      providerConfigData: [],
      providerConfigDataLoading: false,
    };
  }

  componentDidMount() {
    this.updateProviderList();
  }

  updateProviderList = () => {
    const { history, serviceProviderApi } = this.props;
    this.setState({ providerDataLoading: true });
    const errorCallback = () => {
      this.setState({ providerDataLoading: false });
      message.error("Error fetching Service Provider list");
    };
    const successCallback = (data) => {
      const providerData = convertServiceProviderListToDropdown(data);
      console.log("updateData data", providerData);
      this.setState({ providerData, providerDataLoading: false });
    };
    try {
      serviceProviderApi.getServiceprovider(
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onProviderSelect = (id) => {
    this.setState({ selectedProvider: id, providerConfigData: [] });
    id && this.updateProviderConfigList(id);
  };

  updateProviderConfigList = (id) => {
    const providerId = id || this.state.selectedProvider;
    if (!providerId) return;
    const { history, configManagementApi } = this.props;
    this.setState({ providerConfigDataLoading: true });
    const errorCallback = () => {
      this.setState({ providerConfigDataLoading: false });
      message.error("Error fetching Provider Config list");
    };
    const successCallback = (data) => {
      const providerConfigData = convertServiceProviderConfigList(data);
      console.log("updateData data", providerConfigData);
      this.setState({ providerConfigData, providerConfigDataLoading: false });
    };
    try {
      configManagementApi.getConfigByProviderId(
        providerId,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback();
    }
  };

  onActionClick = (action, record) => () => {
    this.setState({ action, record });
  };

  onSubmit = ({ update = true, redirect = true } = {}) => {
    update && this.updateProviderConfigList();
    redirect && this.setState({ action: null, record: null });
  };

  onStatusChange = (record, status) => {
    try {
      console.log("onStatusChange", status, record);
      const callback = statusChangeApiCallback({
        props: this.props,
        recordName: record.name,
        errorRollback: () => this.changeStatus(record, !status),
      });
      this.props.configManagementApi.statusUpdateProviderConfig(
        record.providerId,
        { status: status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE },
        callback
      );
      this.changeStatus(record, status);
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  deleteServiceProviderConfig = (record) => {
    const { history, configManagementApi } = this.props;
    const errorCallback = (error) => {
      this.setState({deleteConfigDataLoading:false})
      console.log("Error deleting config", error);
      message.error("Unable to delete");
    };
    const successCallback = (data) => {
      this.setState({deleteConfigDataLoading:false})
      message.success("Config Deleted Successfully");
      this.updateProviderConfigList();
    };
    try {
      this.setState({deleteConfigDataLoading:true})
      const config = {
        config: record.config,
        providerid: record.providerId,
      };
      configManagementApi.removeProviderConfig(
        config,
        apiCallback({ history, errorCallback, successCallback })
      );
    } catch (error) {
      errorCallback(error);
    }
  };

  changeStatus = (record, status) => {
    try {
      const { configId } = record;
      const providerConfigData = [...this.state.providerConfigData];
      providerConfigData.forEach((item) => {
        if (item.configId === configId) {
          item.status = status ? EntityStatus.ACTIVE : EntityStatus.INACTIVE;
        }
      });
      this.setState({ providerConfigData });
    } catch (error) {
      message.error(`Error changing status of ${record.name}`);
    }
  };

  render() {
    const {
      action,
      record,
      providerData,
      providerDataLoading,
      selectedProvider,
      providerConfigData,
      deleteConfigLoading,
      providerConfigDataLoading,
    } = this.state;
    return (
      <MainPage>
        <div className="service-provider-config-container">
          {!action ? (
            <ListServiceProviderConfig
              providerData={providerData}
              providerDataLoading={providerDataLoading}
              selectedProvider={selectedProvider}
              providerConfigData={providerConfigData}
              providerConfigDataLoading={providerConfigDataLoading}
              deleteConfigLoading={deleteConfigLoading}
              onProviderSelect={this.onProviderSelect}
              onActionClick={this.onActionClick}
              onStatusChange={this.onStatusChange}
              deleteServiceProviderConfig={this.deleteServiceProviderConfig}
              parentBread={this.header}
            />
          ) : (
            <ServiceProviderConfigForm
              action={action}
              record={record}
              providerData={providerData}
              providerDataLoading={providerDataLoading}
              onSubmit={this.onSubmit}
              onActionClick={this.onActionClick}
              parentBread={this.header}
            />
          )}
        </div>
      </MainPage>
    );
  }
}

ServiceProviderConfig.propTypes = {
  parentBread: PropTypes.array,

  serviceProviderApi: PropTypes.object,
  configManagementApi: PropTypes.object,
};

const mapStateToProps = (state) => ({
  serviceProviderApi: state.apis.serviceProviderApi,
  configManagementApi: state.apis.configManagementApi,
});
const connectedServiceProviderConfig = connect(mapStateToProps)(
  ServiceProviderConfig
);
export default withRouter(connectedServiceProviderConfig);
